const BroadcastGroups = {
  BROADCAST_GROUPS_ADDING: 'broadcastGroups/add',
  BROADCAST_GROUPS_UPDATE: 'broadcastGroups/update',
  BROADCAST_GROUPS_DELETE: 'broadcastGroups/delete',
  BROADCAST_GROUPS_ASSIGN_THEME: 'broadcastGroups/assignThemes',
  BROADCAST_GROUPS_STATUS_UPDATE: 'broadcastGroups/statusUpdate',
  BROADCAST_GROUPS_ACTIVATE_STATUS: 'broadcastGroups/ActivateStatusUpdate'
};

export default BroadcastGroups;
